import { NavLink } from "../types/navLink";

export const navLinks: NavLink[] = [
  {
    link: "Présentation",
    index: 0,
    id: "#presentation"
  },
  {
    link: "Mes travaux",
    index: 1,
    id: "#mes-travaux"
  },
  {
    link: "Me contacter",
    index: 2,
    id: "#me-contacter"
  },
]